import { useCalculator } from '@/hooks/useCalculator';
import CalcHeader from './components/CalcHeader';
import PlatformsBlock from './components/PlatformsBlock';
import WorkersBlock from './components/WorkersBlock';
import TotalBlock from './components/TotalBlock';

export default function Home() {
  const {
    platforms,
    workers,
    workerDays,
    togglePlatform,
    setProfiles,
    setWorkers,
    setWorkerDays,
    result,
  } = useCalculator();

  return (
    <main className="min-h-screen bg-white font-sans">
      <div className="max-w-2xl mx-auto px-6 py-12">
        <CalcHeader />
        <PlatformsBlock
          platforms={platforms}
          onToggle={togglePlatform}
          onProfilesChange={setProfiles}
          enabledCount={result.enabledCount}
        />
        <WorkersBlock
          workers={workers}
          workerDays={workerDays}
          onChange={setWorkers}
          onDaysChange={setWorkerDays}
        />
        <TotalBlock
          platformsRawTotal={result.platformsRawTotal}
          discountRate={result.discountRate}
          discountAmount={result.discountAmount}
          platformsTotal={result.platformsTotal}
          workerTotal={result.workerTotal}
          total={result.total}
          enabledCount={result.enabledCount}
        />
      </div>
    </main>
  );
}
